import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "my-header d-flex" }
const _hoisted_2 = ["textContent", "id"]
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-2" }
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass([
                            'flex',
                            'items-center',
                            'gap-2',
                            'flex-col',
                        ])
}
const _hoisted_6 = { class: "col-sm-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Anotations = _resolveComponent("Anotations")!
  const _component_el_segmented = _resolveComponent("el-segmented")!
  const _component_swPerson = _resolveComponent("swPerson")!
  const _component_PhotoManager = _resolveComponent("PhotoManager")!
  const _component_sFiles = _resolveComponent("sFiles")!
  const _component_LineTime = _resolveComponent("LineTime")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogProfile,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogProfile) = $event)),
    class: "custom bg-light",
    fullscreen: true,
    onOpen: _ctx.onOpen,
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "lock-scroll": "",
    "append-to-body": "",
    "destroy-on-close": true
  }, {
    header: _withCtx(({ titleId }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", {
          textContent: _toDisplayString(_ctx.listActions[_ctx.action].name),
          class: "fw-normal mb-0 w-300px",
          id: titleId
        }, null, 8, _hoisted_2),
        (_ctx.gblAccount?.ta == _ctx.ta)
          ? (_openBlock(), _createBlock(_component_Anotations, {
              key: 0,
              id: _ctx.dataProfile.idpayroll,
              target: 'payroll',
              status: _ctx.status
            }, null, 8, ["id", "status"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_segmented, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
            options: _ctx.options,
            direction: 'vertical',
            size: 'default',
            class: "bg-white border w-100 rounded"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("i", {
                  class: _normalizeClass(`${scope.item.icon} fs-3x`)
                }, null, 2),
                _createElementVNode("div", null, _toDisplayString(scope.item.label), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_scrollbar, {
            height: _ctx.altura<=500 ? '500px' : (_ctx.altura-10)+'px',
            always: ""
          }, {
            default: _withCtx(() => [
              (_ctx.activeTab == 'tab1')
                ? (_openBlock(), _createBlock(_component_swPerson, {
                    key: 0,
                    origin: 'payroll',
                    action: _ctx.action,
                    params: _ctx.dataProfile,
                    idinstitution: _ctx.idinstitution,
                    onOnResponse: _ctx.onResponse
                  }, null, 8, ["action", "params", "idinstitution", "onOnResponse"]))
                : _createCommentVNode("", true),
              (_ctx.activeTab == 'tab2')
                ? (_openBlock(), _createBlock(_component_PhotoManager, {
                    key: 1,
                    idperson: _ctx.dataProfile.idperson
                  }, null, 8, ["idperson"]))
                : _createCommentVNode("", true),
              (_ctx.activeTab == 'tab3')
                ? (_openBlock(), _createBlock(_component_sFiles, {
                    key: 2,
                    idacrd: _ctx.dataProfile.idperson,
                    folder: 'files',
                    target: 'payroll'
                  }, null, 8, ["idacrd"]))
                : _createCommentVNode("", true),
              (_ctx.activeTab == 'tab4')
                ? (_openBlock(), _createBlock(_component_LineTime, {
                    key: 3,
                    id: _ctx.dataProfile.idpayroll,
                    target: "payroll"
                  }, null, 8, ["id"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["height"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpen", "onOpened", "onClosed"]))
}